import type { Summer2026SaleVariant } from '~/features/promotions/constants/summer-2026-sale';
import {
  getSummer2026SaleSlideKey,
  getSummer2026SaleVariant,
  resolveSummer2026SaleVariant,
} from '~/features/promotions/utils/get-summer-2026-sale-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const SUMMER_2026_CAMPAIGN_ID = 'summer-2026';

export const summer2026CampaignCore: Pick<
  PromoCampaignSurfaceRenderers<Summer2026SaleVariant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: SUMMER_2026_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getSummer2026SaleSlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getSummer2026SaleVariant(forcedPromotionId) != null || getSummer2026SaleVariant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getSummer2026SaleVariant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveSummer2026SaleVariant(forcedPromotionId, promotionId),
};
